import React, { useState } from "react"

import { ArrowLeft, Loader2 } from "lucide-react"

import { Button } from "@/components/ui/button"
import { NEW_APPLICATION, useApplication } from "@/contexts/ApplicationContext"
import { useToast } from "@/hooks/use-toast"
import { signOut } from "@/services/authService"

import Header from "./Header"

interface AppLayoutProps {
  children: React.ReactNode
  showJobPosting?: boolean
}

const AppLayout: React.FC<AppLayoutProps> = ({ children, showJobPosting = true }) => {
  const [isLoading, setIsLoading] = useState(false)
  const { toast } = useToast()
  const { setApplication } = useApplication()

  const handleBackToJobPostings = async () => {
    setIsLoading(true)
    try {
      // Clear application data from local storage
      localStorage.removeItem("currentApplicationId")
      localStorage.removeItem("currentJobId")

      // Sign out from Supabase auth
      const { success, error } = await signOut()
      setApplication(NEW_APPLICATION)

      if (success) {
        window.location.href = "/"
      } else {
        console.error("Error signing out:", error)
        toast({
          title: "Error",
          description: "There was an issue signing out. Please try again.",
          variant: "destructive",
        })
      }
    } catch (error) {
      console.error("Unexpected error during sign out:", error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-7xl px-4 pb-4 pt-4">
        <Button
          variant="ghost"
          className="mb-2 flex items-center gap-1 text-gray-600 hover:bg-gray-100 hover:text-black"
          onClick={handleBackToJobPostings}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Loader2 className="mr-1 h-4 w-4 animate-spin" />
              Please wait...
            </>
          ) : (
            <>
              <ArrowLeft className="h-4 w-4" />
              Back to Job Postings
            </>
          )}
        </Button>

        <Header showJobPosting={showJobPosting} />
      </div>
      <main className="mx-auto max-w-7xl px-4">{children}</main>
    </div>
  )
}

export default AppLayout
